<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <da-list :das="das" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DaList from "@/components/da/DaList";
import { mapState } from "vuex";

export default {
  components: {
    DaList,
  },
  computed: {
    ...mapState("Da", ["das"]),
  },
  created() {
    this.$store.dispatch("Da/getDAs");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
